import PropTypes from 'prop-types';

export const limitString = (stringValue, stringsQtd) => {
  if (typeof stringValue !== 'string') {
    return stringValue;
  }

  if (stringsQtd) {
    if(stringValue.length > stringsQtd) {
      return stringValue.substring(0, stringsQtd - 3) + '...';
    }
    return stringValue;
  }

  if (stringValue.length > 80) {
    return stringValue.substring(0, 80 - 3) + '...';
  }

  return stringValue;
};
limitString.propTypes = {
  stringValue: PropTypes.string
};

export const stringToNumber = (stringValue) => {
  if (typeof stringValue !== 'string') {
    return stringValue;
  }

  //const cleanedString = stringValue.replace(',', '.');
  const cleanedString = stringValue.replace(/\./g, '');

  const number = parseFloat(cleanedString.replace(',', '.'));

  return number;
}

export const currencyStringToFloat = (str) => {
  str = str.replace(/\./g, '');
  str = str.replace(',', '.');
  str = str.replace('R$', '');

  return parseFloat(str);
}

stringToNumber.propTypes = {
  stringValue: PropTypes.string
};
